var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_4949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4165 4.25016H3.83317C3.39114 4.25016 2.96722 4.42576 2.65466 4.73832C2.3421 5.05088 2.1665 5.4748 2.1665 5.91683C2.1665 6.35886 2.3421 6.78278 2.65466 7.09534C2.96722 7.4079 3.39114 7.5835 3.83317 7.5835H4.24984M6.74984 5.91683L8.4165 4.25016L6.74984 2.5835V5.91683Z",
    stroke: "#4A5056",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_4949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardUp);
export default __webpack_public_path__ + "static/media/arrow-forward-up.568ad0d468d60e23de9e17fac096f6a4.svg";
export { ForwardRef as ReactComponent };